<template>
  <v-container fluid>
    <!-- <v-toolbar dark color="primary" class="mb-1" elevation="2">
      <v-toolbar-title>Coin History</v-toolbar-title
      >
      <v-spacer></v-spacer>
    </v-toolbar> -->
    <v-row justify="end" class="ma-1">
      <v-col cols="2" class="pa-0 mb-2">
        <v-btn color="primary" @click="openRedeemDialog()">Reedem Coins</v-btn>
      </v-col>
    </v-row>
    <CoinHistoryRedeemDialog
      v-model="redeemDialog"
      @redeem-success="onRedeemSuccess"
    />
    <v-dialog v-model="redeemSuccessDialog" max-width="40%">
      <v-card>
        <v-card-title
          >Your request to redeem coins has been submitted
          successfully.</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeRedeemSuccessDialog()"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container fluid class="pa-0">
      <CustomDataTable
        :headers="coinHistoryHeaders"
        :items="coinHistory"
        :items-per-page="7"
      >
        <template v-slot:[`item.courseName`]="{ item }">
          {{ item.courseName ? item.courseName : "--" }}
        </template>
        <template v-slot:[`item.chapterName`]="{ item }">
          {{ item.chapterName ? item.chapterName : "--" }}
        </template>
        <template v-slot:[`item.lessonName`]="{ item }">
          {{ item.lessonName ? item.lessonName : "--" }}
        </template>
        <template v-slot:[`item.compName`]="{ item }">
          {{ item.compName ? item.compName : "--" }}
        </template>
        <template v-slot:[`item.quizName`]="{ item }">
          {{ item.quizName ? item.quizName : "--" }}
        </template>
        <template v-slot:[`item.className`]="{ item }">
          {{ item.className ? item.className : "--" }}
        </template>
        <template v-slot:[`item.assignmentNumber`]="{ item }">
          {{ item.assignmentNumber ? item.assignmentNumber : "--" }}
          <v-chip
            x-small
            text-color="success"
            class="ml-1"
            color="success"
            outlined
            v-if="item.assignmentType"
          >
            {{ item.assignmentType }}
          </v-chip>
        </template>
        <template v-slot:[`item.createdDate`]="{ item }">
          {{ formatDateTime(item.createdDate) }}
        </template>
        <template v-slot:[`item.coin`]="{ item }">
          <span
            v-if="item.type == 'CREDIT'"
            class="success--text"
            style="font-weight: 500"
          >
            + {{ item.coin }}
          </span>
          <span v-else class="error--text" style="font-weight: 500">
            - {{ item.coin }}
          </span>
        </template>
      </CustomDataTable>
    </v-container>
  </v-container>
</template>
<script>
import axios from "axios";
import {
  BASE_URL,
  GET_COIN_HISTORY,
  GET_COIN_BALANCE,
} from "@/common/apiEndpoints";
import { getAxiosOptions, formatDateTime } from "@/common/utility";
import { GET_TOKEN, GET_USER_TYPE } from "@/store/getters";
import {
  SET_API_ERROR,
  SET_API_SUCCESS,
  SET_COIN_BALANCE,
} from "@/store/mutations";
import { mapGetters, mapMutations } from "vuex";
import CustomDataTable from "./CustomDataTable.vue";
import CoinHistoryRedeemDialog from "./dialogComponents/CoinHistoryRedeemDialog.vue";
import { coinHistoryHeaders } from "@/common/tableHeadersData";
export default {
  data() {
    return {
      coinHistory: [],
      redeemDialog: false,
      redeemSuccessDialog: false,
      coinHistoryHeaders: coinHistoryHeaders,
    };
  },
  computed: {
    ...mapGetters({
      userType: `schoolModule/${GET_USER_TYPE}`,
      token: `schoolModule/${GET_TOKEN}`,
    }),
  },
  components: {
    CustomDataTable,
    CoinHistoryRedeemDialog,
  },
  mounted: function () {
    this.getCoinHistory();
  },
  methods: {
    ...mapMutations({
      setApiSuccess: `schoolModule/${SET_API_SUCCESS}`,
      setApiError: `schoolModule/${SET_API_ERROR}`,
      setCoinBalance: `schoolModule/${SET_COIN_BALANCE}`,
    }),
    formatDateTime(date) {
      return formatDateTime(date);
    },
    openRedeemDialog() {
      this.redeemDialog = true;
    },
    openRedeemSuccessDialog() {
      this.redeemSuccessDialog = true;
    },
    closeRedeemSuccessDialog() {
      this.redeemSuccessDialog = false;
    },
    getCoinHistory() {
      let url = GET_COIN_HISTORY;
      axios
        .get(url, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.coinHistory = res.data.history;
        })
        .catch((error) => {
          error = error.errorMessage;
        });
    },
    onRedeemSuccess() {
      this.getCoinHistory();
      this.openRedeemSuccessDialog();
      this.updateCoinBalance();
    },
    updateCoinBalance() {
      const url = GET_COIN_BALANCE;
      axios
        .get(url, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          let newCoinBalance = res.data.balance;
          this.setCoinBalance(newCoinBalance);
        })
        .catch((error) => {
          error = error.errorMessage;
        });
    },
  },
};
</script>
